<template>
  <div class="collection-login">
    <div class="header">
      手机验证码登录
    </div>
    <div class="login-form">
      <p>手机号</p>
      <van-field v-model="formData.mobile" placeholder="请输入手机号" clearable />
      <p>图形验证码</p>
      <div class="flex">
        <van-field v-model="formData.img_code" placeholder="请输入图形验证码" clearable />
        <img :src="image_code" @click="changeImgCode" />
      </div>
      <p>验证码</p>
      <div class="flex">
        <van-field v-model="formData.code" placeholder="请输入验证码" clearable />
        <van-button @click="sendCode" class="code">{{ sendTimeText }}</van-button>
      </div>
      <button @click="Login" class="login-button">登录</button>
    </div>
  </div>
</template>
<script>
import {
  SendCode,
  GetUserInfo,
  VascularLogin,
  BindMobile,
  imgCode
} from "../../config/interface.js";
import { Dialog, Toast } from "vant";

let codeTimer;
export default {
  data() {
    return {
      sendTimeText: "发送验证码",
      formData: {
        mobile: "",
        img_code: '',
        code: "",
      },
      image_code: '',
      countdown: 60,
      isReSend: true, //能否再次点击发送验证码
      isBind: true,
      showPicker: false,
      codes: {},
      timestamp: new Date().getTime()
    };
  },
  created() {
    if (common.is_weixin) {
      this.getPersonalUserInfo(); //微信登录需要授权 所以要获取用户信息判断是否授权
    }
    this.getImgCode()

  },
  mounted() {
    // if(common.is_weixin){
    //   this.getPersonalUserInfo(); //微信登录需要授权 所以要获取用户信息判断是否授权
    // }

  },
  methods: {
    Login() {
      if (this.isBind == false) {
        Dialog.confirm({
          message: "确定将该微信绑定该手机号？",
        })
          .then(() => {
            if (this.verifyForm()) {
              const url = BindMobile;
              const method = "POST";
              let params = {
                mobile: this.formData.mobile,
                msgcode: this.formData.code,
                country_code: this.area_code,
                code: this.formData.img_code
              };
              fetch(url, params, method).then((res) => {
                if (res.code == 0) {
                  common.toast("登录成功", 1000, "success", () => {
                    localStorage.setItem("token", res.data.user_access_token);
                    this.setUserInfo(res.data.local_data);
                  });
                } else {
                  if (res.code == 901) {
                    Dialog.confirm({
                      message: "您的账号已在PC端注册过，是否强制合并账号？",
                    })
                      .then(() => {
                        const url = BindMobile;
                        const method = "POST";
                        let params = {
                          mobile: this.formData.mobile,
                          msgcode: this.formData.code,
                          country_code: this.area_code,
                          code: this.formData.img_code,
                          merge_account: 1,
                        };
                        fetch(url, params, method).then((res) => {
                          if (res.code == 0) {
                            common.toast("登录成功", 1000, "success", () => {
                              localStorage.setItem("token", res.data.user_access_token);
                              this.setUserInfo(res.data.local_data);
                            });
                          } else {
                            common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => {
                            })
                          }
                        });
                      })
                      .catch(() => { });
                  } else {
                    common.toast(
                      res && res.error_msg ? res.error_msg : "未知错误",
                      1000,
                      "fail",
                      () => { }
                    );
                  }
                }
              });
            }
          })
          .catch(() => { });
      } else {
        if (this.verifyForm()) {
          const url = VascularLogin;
          const method = "POST";
          let params = {
            mobile: this.formData.mobile,
            country_code: this.area_code,
            msgcode: this.formData.code,
            code: this.formData.img_code
          };
          fetch(url, params, method).then((res) => {
            if (res.code == 0) {
              common.toast("登录成功", 1000, "success", () => {
                localStorage.setItem("token", res.data.user_access_token);
                this.setUserInfo(res.data.local_data);
              });
            } else {
              common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => { })
            }
          });
        }
      }
    },
    //验证手机号
    verifyMobile() {
      let mobile = this.formData.mobile;
      if (mobile == "") {
        common.toast("请输入手机号", 1000);
      } else if (!/^1[3456789]\d{9}$/.test(mobile)) {
        common.toast("请输入正确手机号", 1000);
      } else if (this.formData.img_code == '') {
        common.toast("请输入验证码", 1000);
      } else {
        return true;
      }
      return false;
    },
    getImgCode() {
      const url = imgCode;
      const method = "GET";
      fetch(url, {}, method).then((res) => {
        if (res.code == 0) {
          console.log(res.data.base64_image)
          this.image_code = res.data.base64_image
        }
      });
    },
    //区号选择
    onConfirm(value) {
      this.area_code = this.codes[value];
      this.flag_src = this.flags[value];
      this.showPicker = false;
    },
    //点击发送验证码
    sendCode() {
      if (this.isReSend && this.verifyMobile()) {
        this.getCode();
        this.isReSend = false;
      }
    },
    //看是否绑定手机号
    getPersonalUserInfo() {
      if (common.is_weixin()) {
        //微信端页面
        const url = GetUserInfo;
        let params = {};
        const method = "POST";
        fetch(url, params, method).then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.userInfo = JSON.stringify(data);
            localStorage.setItem("userInfo", JSON.stringify(data));
            this.$store.dispatch("storageUserInfo", data);
            if (data.mobile_status == 0) {
              this.isBind = false;
            }
          }
        });
      }
    },
    //得到验证码
    getCode(mobile) {
      const url = SendCode;
      const method = "POST";
      let params = {
        mobile: this.formData.mobile,
        country_code: this.area_code,
        code: this.formData.img_code
      };
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          Toast('发送成功')
          this.sendTime();
        } else {
          console.log("注册");
          this.isReSend = true;
          // this.clearCodeTimer();
        }
      });
    },
    sendTime() {
      codeTimer = setTimeout(() => {
        if (this.countdown == 1) {
          this.clearCodeTimer();
          return;
        } else {
          this.countdown--;
          this.sendTimeText = "重新发送(" + this.countdown + "s)";
          setTimeout(this.sendTime(), 1000);
        }
      }, 1000);
    },
    //清除定时器
    clearCodeTimer() {
      clearTimeout(codeTimer);
      this.isReSend = true;
      this.sendTimeText = "获取验证码";
      this.countdown = 60;
    },
    //验证表单
    verifyForm() {
      if (!this.verifyMobile()) {
      } else if (this.formData.code == "") {
        common.toast("请输入验证码", 1000);
      } else {
        return true;
      }
      return false;
    },
    setUserInfo(data) {
      localStorage.setItem("userInfo", JSON.stringify(data));
      this.$store.dispatch("storageUserInfo", data);
      let url = this.$route.query.url ? this.$route.query.url : null;
      // let id=this.$route.query.id? this.$route.query.id :null;
      // let meeting_id=this.$route.query.meeting_id? this.$route.query.meeting_id :null;
      // let chapter_id=this.$route.query.chapter_id? this.$route.query.chapter_id :null;
      // let channel_id=this.$route.query.channel_id? this.$route.query.channel_id :null;
      // if(id){
      //   url=url+'&id='+id;
      // }
      // if(meeting_id){
      //   url=url+'&meeting_id='+meeting_id;
      // }
      // if(chapter_id){
      //   url=url+'&chapter_id='+chapter_id;
      // }
      // if(channel_id){
      //   url=url+'&channel_id='+channel_id;
      // }
      if (url) {
        window.location.replace(url);
      } else {
        this.$router.replace({
          path: "/vascularNews",
        });
      }
    },
    //获取用户信息
    getUserInfo() {
      const url = GetUserInfo;
      const method = "POST";
      let params = {};
      fetch(url, params, method)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            localStorage.setItem("userInfo", JSON.stringify(data));
            this.$store.dispatch("storageUserInfo", data);
            let url = this.$route.query.url ? this.$route.query.url : null;
            if (url) {
              window.location.replace(url);
            } else {
              this.$router.replace({
                path: "/vascularNews",
              });
            }
          }
        })
        .catch(() => { });
    },
    changeImgCode() {
      this.getImgCode()
    },
  },
  destroyed() {
    this.clearCodeTimer();
  },
};
</script>
<style lang="scss" scoped>
.collection-login {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/images/collection/background.png');
  background-size: contain;
  padding: 0 30px;

  .header {
    padding: 60px 0;
    font-size: 20px;
    line-height: 30px;
  }

  .login-form {
    p {
      line-height: 40px;
      font-size: 14px;
      color: #333333;
    }

    .van-field {
      border-radius: 5px;
      border: 2px solid #e4e4e4;
    }

    .code {
      color: #B01C06;
      position: absolute;
      border: 0;
      background: transparent;
      right: 25px;
    }
  }

  .login-button {
    display: block;
    margin: 50px 0;
    width: 50%;
    border-radius: 5px;
    height: 44px;
    background: #B01C06;
    font-size: 17px;
    color: #fff;
    border: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/contributions/bind.vue